<lib-button [theme]="theme" [prefixIcon]="prefixIcon" [disabled]="disabled" [fullWidth]="fullWidth" [small]="small"
  [centered]="centered" (buttonClick)="onUploadButtonClick()">
  {{ text }}
</lib-button>

<ng-template #uploadRef>
  <div class="modal">
    <div>
      <p class="lib-legend">{{ title }}</p>
      <dropzone [config]="dropzoneConfig" message="Click or drag images here to upload" (error)="onUploadError($event)"
        (success)="onUploadSuccess($event)" (canceled)="onUploadCancel()"></dropzone>
    </div>
    <nav class="lib-nav">
      <span class="lib-spacer"></span>
      <lib-button theme="flat-primary" (buttonClick)="startFileUploading()" [disabled]="toggle.working || !file">
        Submit
      </lib-button>
    </nav>
  </div>
</ng-template>